export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "oauth_login_fail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["로그인 인증 실패"])}
    }
  })
}
